<template>
	<BaseSidebar title="Access List" @close="$emit('close')">
		<!-- user list -->
		<v-list class="access-list">
			<v-progress-linear v-if="loading" indeterminate />
			<template v-for="(user, i) in accessListUsers">
				<v-list-item :key="i">
					<v-list-item-title>{{ user.name }}</v-list-item-title>
					<v-list-item-action>{{ startCase(user.mode) }}</v-list-item-action>
					<v-list-item-action
						><menu-default
							icon="fas fa-ellipsis-v"
							:items="[
								{
									title: 'Remove Access',
									action: () => removeAccess(user),
								},
							]"
						></menu-default
					></v-list-item-action>
				</v-list-item>
				<v-divider :key="'divider-' + i" />
			</template>
		</v-list>

		<!-- add user -->
		<template #actions>
			<v-form ref="form" lazy-validation @submit.prevent="submitUser(form)">
				<v-card-title>Add User</v-card-title>
				<v-card-text class="pb-0">
					<v-autocomplete
						v-model="form.userId"
						label="Staff"
						:items="staffList"
						:loading="loading"
						:rules="[rules.required]"
						item-text="name"
						item-value="_id"
						clearable
						dense
					></v-autocomplete>
					<v-radio-group
						v-model="form.admin"
						:rules="[rules.required]"
						row
						dense
					>
						<template #label>
							<span class="mr-4">Mode:</span>
						</template>
						<v-radio label="User" :value="false" />
						<v-radio label="Admin" :value="true" />
					</v-radio-group>
				</v-card-text>
				<v-card-actions class="justify-end">
					<v-btn
						outlined
						tile
						color="ocean"
						type="submit"
						:disabled="!formFilled || loading"
						>Add</v-btn
					>
				</v-card-actions>
			</v-form>
		</template>
	</BaseSidebar>
</template>

<script>
import _ from "lodash";
import BaseSidebar from "./Base.vue";
import { mapActions, mapGetters } from "vuex";

const clearForm = () => ({
	userId: null,
	admin: null,
});

export default {
	components: {
		BaseSidebar,
	},

	data() {
		return {
			loading: false,
			form: clearForm(),
		};
	},

	computed: {
		...mapGetters({
			accessListUsers: "locks/users",
			staffList: "locks/staff",
		}),

		rules() {
			return {
				required: (val) => ![null, undefined].includes(val) || "Required!",
			};
		},

		formFilled() {
			return !_.some(this.form, _.isNil);
		},
	},

	created() {
		this.init();
	},

	methods: {
		startCase: _.startCase,
		...mapActions({
			getUsers: "locks/getUsers",
			getStaff: "locks/getStaff",
			addUser: "locks/addUser",
			removeUser: "locks/removeUser",
		}),

		async init() {
			this.loading = true;
			return Promise.all([this.getUsers(), this.getStaff()]).finally(
				() => (this.loading = false)
			);
		},

		async submitUser(user) {
			if (!this.$refs.form.validate()) return;
			this.loading = true;

			try {
				await this.addUser(user);

				Object.assign(this.form, clearForm());
				this.$refs.form.resetValidation();
			} finally {
				await this.init();
			}
		},

		async removeAccess(user) {
			await this.removeUser(user);
		},
	},
};
</script>

<style lang="scss" scoped>
.access-list {
	border: 1px solid #0006;
	height: 200px;
	overflow-y: auto;

	> :last-child {
		display: none;
	}
}
</style>
